import styled from "styled-components";
import { default as BaseBadge } from "../../../common/Badge";
import {
  TableRow as BaseTableRow,
  TableFooter as BaseTableFooter
} from "../../../common/Table";

export const Container = styled.div`
  width: 100%;
  max-width: 100.1rem;
  margin: 4.8rem auto;
  padding: 0 2.4rem;

  ${({ theme }) => theme.media.sm`
    margin: 2.4rem 0;
  `}
`;

export const Group = styled.div`
  margin-bottom: 2.4rem;
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.raised};
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  border-radius: 1.2rem;
  overflow: hidden;
`;

export const GroupTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 2.2rem;
  padding: 1.6rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const Badge = styled(BaseBadge)`
  margin-right: 0.8rem;
`;

export const Street = styled.span`
  font-weight: 600;
`;

export const CityStateZip = styled.span`
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};

  ${({ theme }) => theme.media.sm`
    font-size: 1.3rem;
    line-height: 1.7rem;
  `}
`;

export const TableRow = styled(BaseTableRow)`
  cursor: pointer;
`;

export const TableHeader = styled.thead`
  ${TableRow} {
    cursor: default;
  }
`;

export const TableFooter = styled(BaseTableFooter)`
  ${TableRow} {
    cursor: default;
  }
`;
